module.exports = __webpack_public_path__ + "static/media/profile.3c3c96da.jpg";